export * from './brows';
export * from './ears';
export * from './eyes';
export * from './faces';
export * from './hairs';
export * from './muzzles';
export * from './patterns';
export * from './types';
export const emptyShape = (_color) => '';
